/*  ========================================================================
    # Scripts - Highlight Button
    ========================================================================  */

/**
 * Script that handles highlights the button on a linked card.
 */

const HighlightButton = {
  cfg: {
    cards: document.querySelectorAll('.c-linked-card')
  },

  handler() {
    this.cfg.cards.forEach(card => {
      card.addEventListener('mouseover', () => {
        card.querySelector('.c-button')?.classList.add('c-button--hover');
        card.querySelector('.c-button')?.classList.add('c-button--white-outline--hover');
      });
      card.addEventListener('mouseout', () => {
        card.querySelector('.c-button')?.classList.remove('c-button--hover');
        card.querySelector('.c-button')?.classList.remove('c-button--white-outline--hover');
      });
    });
  },

  init() {
    if (this.cfg.cards !== undefined && this.cfg.cards !== null) {
      this.handler();
    }
  }
};

export default HighlightButton;
